module.exports = __webpack_public_path__ + "static/media/vent-direccio-30.d60d7215.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio-30.svg
// module id = 206
// module chunks = 0